import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class CancellationReasonsDto {
  @Field(t => Int)
  month!: number

  @Field(t => Int)
  year!: number

  @Field(t => Int)
  count!: number
}
